"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  padding-top: 4.5rem;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AccordionBoxContent = function AccordionBoxContent(_ref) {
  var children = _ref.children,
      open = _ref.open;
  return _react.default.createElement(Wrapper, {
    open: open
  }, children);
};

var Wrapper = _styledComponents.default.div(_templateObject(), function (_ref2) {
  var open = _ref2.open;
  return open ? 'block' : 'none';
});

AccordionBoxContent.propTypes = {
  children: _propTypes.node.isRequired,
  open: _propTypes.bool.isRequired
};
var _default = AccordionBoxContent;
exports.default = _default;